/* tslint:disable */
/* eslint-disable */
/**
 * Muze REST API
 * API Data backend for Muze
 *
 * The version of the OpenAPI document: 1.6.0
 * Contact: dash@muze.nyc
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FFMember
 */
export interface FFMember {
    /**
     * 
     * @type {number}
     * @memberof FFMember
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof FFMember
     */
    uuid?: string;
    /**
     * 
     * @type {number}
     * @memberof FFMember
     */
    chat?: number;
    /**
     * 
     * @type {number}
     * @memberof FFMember
     */
    user: number;
    /**
     * 
     * @type {Date}
     * @memberof FFMember
     */
    lastOpened?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FFMember
     */
    muted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FFMember
     */
    alertSetting?: string;
}

export function FFMemberFromJSON(json: any): FFMember {
    return FFMemberFromJSONTyped(json, false);
}

export function FFMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): FFMember {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'uuid': !exists(json, 'uuid') ? undefined : json['uuid'],
        'chat': !exists(json, 'chat') ? undefined : json['chat'],
        'user': json['user'],
        'lastOpened': !exists(json, 'last_opened') ? undefined : (new Date(json['last_opened'])),
        'muted': !exists(json, 'muted') ? undefined : json['muted'],
        'alertSetting': !exists(json, 'alert_setting') ? undefined : json['alert_setting'],
    };
}

export function FFMemberToJSON(value?: FFMember | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uuid': value.uuid,
        'chat': value.chat,
        'user': value.user,
        'last_opened': value.lastOpened === undefined ? undefined : (value.lastOpened.toISOString()),
        'muted': value.muted,
        'alert_setting': value.alertSetting,
    };
}


